



















import { Vue, Prop, Component } from "vue-property-decorator"
import { WebinarInfo } from "@/models/WebinarInfo"

import "@/assets/infoTab.css"
@Component
export default class InfoTab extends Vue {
  @Prop() info!: WebinarInfo
}
